var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"color":""}},[_c('Toolbar'),_c('UpdateAccount'),_c('FooterPane')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }